// Timestep-scrubber intent handlers. Inert until a multi-step reader
// populates `availableSteps`; prev/next clamp at the bounds, set
// validates membership.

import { INTENTS } from '@store/intents';
import { params } from '@store/instance';
import type { Store } from '@store/store';
import type { State } from '@store/schema';
import type { ViewerContext } from '../context';

function indexOfStep(step: number): number {
    return params.availableSteps.indexOf(step);
}

export function register(store: Store<State>, _viewer: ViewerContext): Array<() => void> {
    const offs: Array<() => void> = [];

    offs.push(store.onIntent(INTENTS.STEP_SET, (p) => {
        if (!p || typeof p.step !== 'number') return;
        if (indexOfStep(p.step) < 0) return;
        params.currentStep = p.step;
    }));

    offs.push(store.onIntent(INTENTS.STEP_PREV, () => {
        const i = indexOfStep(params.currentStep);
        if (i < 0) return;
        const next = params.availableSteps[Math.max(0, i - 1)];
        if (typeof next === 'number') params.currentStep = next;
    }));

    offs.push(store.onIntent(INTENTS.STEP_NEXT, () => {
        const i = indexOfStep(params.currentStep);
        if (i < 0) return;
        const last = params.availableSteps.length - 1;
        const next = params.availableSteps[Math.min(last, i + 1)];
        if (typeof next === 'number') params.currentStep = next;
    }));

    return offs;
}
